import { useState } from 'react';

import Image from 'next/image';

import Layout from '@/modules/core/components/Layout';
import ContactForm from '@/tayara-kit/ContactForm';

const Home = () => {
  const shops = [
    {
      id: 1,
      name: 'build immobilier',
      avatar: 'https://storage.googleapis.com/caravel-images/logo.svg',
    },
    {
      id: 2,
      name: 'ketata',
      avatar: 'https://storage.googleapis.com/caravel-images/ketata-logo.svg',
    },
    {
      id: 3,
      name: 'SNI',
      avatar:
        'https://storage.googleapis.com/caravel-images/logo-sni-vertical.png',
    },
    {
      id: 4,
      name: 'promotion immobiliére',
      avatar: 'https://storage.googleapis.com/caravel-images/logo2.svg',
    },
    {
      id: 4,
      name: 'SIF',
      avatar:
        'https://storage.googleapis.com/caravel-images/426595109_807719984701799_9048428937594474089_n.jpg',
    },
  ];
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  const cards = [
    {
      title: 'Pourquoi Immoxpert ?',
      shortDescription: 'Élargissez votre portée avec des campagnes ciblées.',
      fullDescription: [
        "L'objectif principal sera  d’augmenter votre visibilité",
        '  Vous aider à vendre rapidement vos biens immobiliers',
        '  Toucher un plus large public facilement et ainsi attirer les clients .',
        ' Mettre en avant vos projets,  les booster à travers les différents services proposés sur le site.',
        ' Vous aurez votre propre interface en ligne, votre adresse physique, le lien de votre page facebook sera en ligne pour les intéressés',
      ],
    },
    {
      title: 'Génération de leads',
      shortDescription: 'Les potentiels acheteurs pourront vous..',
      fullDescription: [
        "        Les potentiels acheteurs pourront vous contacter soit à travers le numéro de téléphone disponible sur votre interface ou entrer en contact avec vous directement via l'interface chat ou via whatsapp.",
        'Le futur acheteur souhaitant être contacté pourra aussi insérer son numéro de téléphone dans le formulaire dédié pour chaque bien immobilier.',
        'Un partage journalier et instantané avec vous sera fait avec les  leads reçus pour la prise  en charge par votre équipe commerciale.',
      ],
    },
    {
      title: 'Modération de votre projet en ligne',
      shortDescription: 'Assurez-vous que vos projets sont bien présentés.',
      fullDescription: [
        ' Vos projets seront insérés par notre service client avec tous les détails et descriptifs nécessaires pour chaque bien immobilier.',
        'La modération de vos projets en ligne sera assurée par notre service client, pour répondre aux besoins et demandes des utilisateurs.',
        'Des rapports analytiques seront inclus dans votre shop (#Vues, #clics, #Leads par bien et par projet) .',
      ],
    },
    {
      title: 'Digital 360°',
      shortDescription: 'Partenaire en Communication Digitale',
      fullDescription: [
        'Tayara peut vous accompagner à l’élaboration, la conception et l’exécution de votre stratégie de communication digitale via des offres adaptées selon votre besoin et la durée de votre campagne allant de la création des visuels à la gestion des campagnes via les canaux retenus.',

        'Audience Extension  Génération de leads et d’audience via des campagnes sur les réseaux sociaux. Weekly, Monthly campaigns, targeting Tunisie et International.Exploitation de Google Ads afin de générer des leads de qualité.',

        'Produits VAS sur la plateforme Tayara.tn Mise en avant de vos produits sur tayara à travers des services exclusifs et à fort potentiel de génération de leads.',
        ' Sales Support Qualification de leads et prise de RDV à travers notre call center.',
      ],
    },
  ];
  const offers = [
    {
      title: 'Engagement 6 mois',
      descriptions: [
        'Com digitale, Listing & génération de leads ',
        'Listing des projets promoteurs ',
        ' Modération de vos biens immobiliers par notre service client ',
        ' suivi et partage quotidien des leads reçus ',
        ' Rapport mensuel et recommandations ',
        '1 campagne gratuite de mise en avant de vos biens sponsorisées sur nos réseaux sociaux',
      ],
    },
    {
      title: 'Engagement 12 mois',
      descriptions: [
        'Com digitale, Listing & génération de leads',
        'Listing des projets promoteurs',
        'Modération de vos biens immobiliers par notre service client ',
        'suivi et partage quotidien des leads reçus',
        ' Rapport mensuel et recommandations',
        ' 2 campagnes gratuites de mise en avant de vos biens sponsorisées sur nos réseaux sociaux',
      ],
    },
  ];

  return (
    <div>
      {/* First Section: Background Image with Title and Button */}
      <div className="relative w-full h-[60vh] m-5 mx-auto rounded-lg overflow-hidden">
        <Image
          src="https://storage.googleapis.com/caravel-images/hero%20marquee%20landing%20page.jpg"
          alt="Real Estate Background"
          layout="fill"
          objectFit="cover"
          priority
        />

        <div className="absolute inset-0 flex flex-col items-center justify-center font-poppins text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold mb-4 text-black">
            Boostez <br /> votre projet immobilier
          </h1>
          <p className="text-black mb-2 text-xl font-poppins text-center">
            {'Avec nos offres adaptées !'}
          </p>
          <a
            href="#contact"
            className="bg-primary hover:bg-red-700 text-white font-bold py-2 px-10  text-xl rounded-md "
          >
            Contactez-nous
          </a>
        </div>
      </div>

      {/* Second Section: A propos de nous */}
      <div className="bg-gray-100 py-10 px-10 ">
        <h2 className="text-3xl font-bold text-bg-neuf-200 mb-6 text-center ">
          A propos de nous
        </h2>
        <p className="text-lg mb-6 text-center">
          Fort de son savoir-faire en termes de places de marché, et à la
          demande des acteurs du marché immobilier,
          <br />
          Tayara a développé la plateforme Immoxpert, dédiée à l’immobilier
          neuf. <br />
          IMMoxpert a intégré Tayara en tant que verticale exclusive pour les
          promoteurs pour bénéficier de l’audience et du trafic de la première
          marketplace généraliste en Tunisie. <br />
          Cette plateforme a comme objectif de rassembler en un seul lieu toutes
          les habitations et locaux commerciaux neufs, construits ou en
          chantier, ainsi que les services associés (architectes, décoration,
          travaux…).
          <br />
          Grâce au savoir-faire technologique et marketing de Tayara, site
          tunisien n°1, les promoteurs immobiliers et les prestataires de
          service pourront ainsi développer leurs affaires en s’appuyant sur le
          reach du digital, à la fois en Tunisie et à l&apos;international.
        </p>
      </div>
      <div className="bg-gray-100 py-5 px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-center">
          {[
            { value: '+1.5M', description: 'Moyenne des visites mensuelles' },
            {
              value: '+40%',
              description: "Audience intéressée par l'immobilier",
            },
            { value: '+20%', description: 'Traffic TRE ' },
            { value: '+200K', description: 'Leads générés par mois' },
          ].map((kpi, index) => (
            <div key={index} className="p-6 ">
              <h3 className="text-4xl font-extrabold text-neuf-200 mb-2">
                {kpi.value}
              </h3>
              <p className="text-lg">{kpi.description}</p>
            </div>
          ))}
        </div>
        <div className=" text-center my-10">
          <a
            href="#offres"
            className="bg-neuf-100 hover:bg-neuf-200 text-white font-bold py-3   text-lg rounded-lg px-12"
          >
            Voir nos offres
          </a>
        </div>
      </div>

      {/*  Section for Promoters' Logos */}
      <div className="bg-white py-10">
        <h2 className="text-3xl font-bold  mb-6 text-center ">
          Quelques Références
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 gap-2 justify-items-center">
          {shops?.map((shop) => (
            <div
              key={shop.id}
              className="w-40 h-40 flex items-center justify-center rounded-full overflow-hidden shadow-lg"
            >
              <img
                src={shop.avatar}
                alt={`Logo ${shop.name}`}
                className="w-30 h-20 object-contains m-2"
              />
            </div>
          ))}
        </div>
        <div className="bg-white py-20 px-10">
          <h2 className="text-3xl font-bold text-center text-bg-neuf-200 mb-10">
            <span className="font-extrabold text-4xl">
              Boostez votre visibilité et vendez vos biens immobiliers{' '}
            </span>{' '}
            <br></br>rapidement avec nos offres adaptées !
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {cards.map((card, index) => (
              <div key={index} className="bg-white shadow-md rounded-lg">
                {/* Card Header */}
                <div
                  className={`${
                    index === 0 || index === 2 ? 'bg-[#98BEDE]' : 'bg-[#7E96B2]'
                  }  rounded-t-lg text-center py-4`}
                >
                  <h3 className="text-[#35536e] font-bold text-lg">
                    {card.title}
                  </h3>
                </div>

                {/* Card Body */}
                <div className="p-4 text-center">
                  {expandedCard === index ? (
                    card.fullDescription.map((line, i) => (
                      <>
                        <br></br>
                        <p key={i} className="text-[#535353]">
                          {line}
                        </p>
                      </>
                    ))
                  ) : (
                    <p className="text-[#535353]">{card.shortDescription}</p>
                  )}
                </div>

                {/* Expand/Collapse Button */}
                <div className="flex justify-center p-4">
                  <button
                    onClick={() => handleToggle(index)}
                    className="bg-white text-[#535353] border border-[#535353] rounded-lg px-4 py-2 hover:bg-gray-100"
                  >
                    {expandedCard === index ? 'Voir moins' : 'Voir plus'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className=" text-center my-10">
          <a
            href="#contact"
            className="bg-neuf-100 hover:bg-neuf-200 text-white font-bold py-3   text-lg rounded-lg px-12"
          >
            contactez nous
          </a>
        </div>
      </div>
      {/* Third Section: Nos offres et services */}
      <div id="offres" className="bg-white py-20 px-10">
        <h2 className="text-3xl font-bold   text-center ">
          Nos offres et services
        </h2>
        <p className="text-center text-xl mb-4">
          {'Communication digitale, Listing & génération de leads'}
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
          {offers.map((offer, index) => (
            <div key={index} className="rounded-lg shadow-lg overflow-hidden">
              {/* Card Header */}
              <div className="bg-neuf-100 text-white text-center py-2 min-h-[20px]">
                <h3 className="text-2xl font-bold">{offer.title}</h3>
              </div>
              {/* Card Body */}
              <div className="p-6 bg-gray-200">
                <ul className="list-disc list-inside mt-4 space-y-2">
                  {offer.descriptions.map((descItem, idx) => (
                    <li key={idx}>{descItem}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className=" text-center my-10">
        <a
          href="#contact"
          className="bg-neuf-100 hover:bg-neuf-200 text-white font-bold py-3   text-lg rounded-lg px-12"
        >
          contactez nous
        </a>
      </div>
      {/*  Section for Promoters Logos */}
      <div className="bg-white py-10">
        <h2 className="text-3xl font-bold mb-6 text-center ">
          Ils nous ont fait confiance
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 gap-2 justify-items-center">
          {shops?.map((shop) => (
            <div
              key={shop.id}
              className="w-40 h-40 flex items-center justify-center rounded-full overflow-hidden shadow-lg"
            >
              <img
                src={shop.avatar}
                alt={`Logo ${shop.name}`}
                className="w-30 h-20 object-contains m-2"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Contact Section */}
      <div id="contact" className="py-20 px-10 bg-neutral-300 ">
        <h2 className="text-3xl font-bold text-bg-neuf-200 mb-6 text-center">
          Contactez-nous maintenant pour débuter votre aventure{' '}
          <span className="font-bold text-neuf-100">Immoxpert</span> <br></br>
          Équipe Immoxpert: 93 941 034
        </h2>

        <ContactForm
          adid={'landing page form'}
          promoteur={'landing page form'}
          title={'landing page form'}
        />
      </div>
    </div>
  );
};

Home.getLayout = function getLayout(page: JSX.Element) {
  return (
    <Layout>
      <Layout.Wide>{page}</Layout.Wide>
    </Layout>
  );
};

export default Home;
